import { config } from "../Environment";

export interface CatalogueExampleCreator {
  name: string;
  email: string;
  firstName: string;
  lastName: string;
  displayName: string;
  title: string;
  bio: string;
}

export interface CatalogueExample {
  _id: string;
  name: string;
  description: string;
  prologue: string;
  epilogue: string;
  prologueTeaser: string;
  epilogueTeaser: string;
  fiPrescription: string;
  prescriptionName: string;
  marketplaceEntityId?: string | null;
  creator?: CatalogueExampleCreator | null;
}

/**
 * Fetch curated public examples for the Example Catalogue. No auth required.
 */
export async function getPublicCatalogueExamples(): Promise<
  CatalogueExample[]
> {
  const response = await fetch(
    `${config.API_BASE}/api/public/catalogue/examples`,
    {
      method: "GET",
      credentials: "include",
    }
  );

  if (!response.ok) {
    throw new Error(
      `Failed to fetch catalogue examples: ${response.statusText}`
    );
  }

  return response.json();
}
